import * as types from './action-types';
import * as endpoints from '../helpers/endpoints';
import { actions } from 'react-redux-form';
import apiRequest from '../helpers/apiRequest';

import * as billetList from '../helpers/billetList';

export const getRegionalCode = billetName => {
    const regional = {
        east: ['01', '04', '06'],
        west: ['08', '09', '12']
    };

    return billetName.includes('ERR') ? regional.east : regional.west;
};

export const fetchCurrentlyAssignedTo = () => (dispatch, getState) => {
    const userInfo = getState().data.userInfo;
    const userBilletLocation = userInfo.Billet.location;
    const userBilletName = userInfo.Billet.name;
    let regionalCode;
    //Check if include inactive is selected to remove the filter active from url default it includes it.
    let isActiveFilter = getState().adminForm.inActive.length
        ? ''
        : '&filter[User.isActive]=true';

    dispatch(resetState(true));

    //Regional User
    if (userBilletLocation === 'Regional') {
        regionalCode = getRegionalCode(userBilletName);
    }

    /* prettier-ignore */
    const baseQuery = '&fields[User]=id,firstName,lastName,rank&fields[Billet]=name,location&filter[MappedUsername.serviceProviderSymbol]=em2&filter[MappedUsername.allowed]=1';

    const listOfBillets = {
        /* prettier-ignore */
        District: () => `${endpoints.AUTH_USER_SEARCH}?include=Billet,MappedUsername,District,*RS,*RSS,*OSS&filter[User.districtId]=${userInfo.District.id}${baseQuery}${isActiveFilter}&filter[Billet.name][in]=${billetList.districtReportBillets}`,
        /* prettier-ignore */
        MCRC: () => `${endpoints.AUTH_USER_SEARCH}?include=Billet,MappedUsername,*District,*RS,*RSS,*OSS${baseQuery}${isActiveFilter}&filter[Billet.name][in]=${billetList.mcrcReportBillets}`,
        /* prettier-ignore */
        Regional: () => `${endpoints.AUTH_USER_SEARCH}?include=Billet,MappedUsername,*District,*RS,*RSS,*OSS&filter[District.code][in]=${regionalCode}${baseQuery}${isActiveFilter}&filter[Billet.name][in]=${billetList.regionalReportBillets}`,
        /* prettier-ignore */
        Other: () => `${endpoints.AUTH_USER_SEARCH}?include=Billet,MappedUsername,*District,*RS,*RSS,*OSS${baseQuery}${isActiveFilter}&filter[Billet.name][in]=${billetList.mcrcReportBillets}`
    };

    apiRequest(
        listOfBillets[userBilletLocation](),
        getState().auth.jwtToken,
        'GET',
        undefined,
        false,
        2
    ).then(payload => {
        let data = payload.data;
        if (userBilletLocation === 'Regional') {
            const location = ['RS', 'OSS', 'RSS', 'District'];
            data = data.filter(item => {
                let isMatch = false;

                if (
                    userBilletName.includes('ERR') &&
                    item.Billet.name.includes('ERR')
                ) {
                    isMatch = true;
                }

                if (
                    userBilletName.includes('WRR') &&
                    item.Billet.name.includes('WRR')
                ) {
                    isMatch = true;
                }

                if (
                    item.District !== null &&
                    location.includes(item.Billet.location)
                ) {
                    isMatch = true;
                }

                return isMatch;
            });
        }

        const userList = data.map(item => {
            return {
                Billet: item.Billet,
                district: item.District && item.District.code,
                value: item.id,
                label: `${item.Billet.name} - ${item.rank} ${item.firstName} ${
                    item.lastName
                }`
            };
        });
        dispatch(fetchCurrentlyAssignedToSuccess(userList));
    });
};

export const fetchCurrentlyAssignedToSuccess = payload => {
    return {
        type: types.FETCH_CURRENTLY_ASSIGNED_TO_SUCCESS,
        payload
    };
};

export const fetchCurrentlyAssignedToEvents = id => (dispatch, getState) => {
    dispatch(fetchCurrentlyAssignedToEventsLoading());
    if (id !== '') {
        apiRequest(
            `${endpoints.EMS}user/${id}/all`,
            getState().auth.jwtToken
        ).then(payload => {
            const newPayload = Object.keys(payload.data).reduce(
                (newData, key) => {
                    const nameMap = (key, item) => {
                        let name;
                        if (item.EventReport) {
                            name = `${item.EventReport.Event.name} (${
                                item.EventReport.subStatus
                            })`;
                        } else if (item.Event) {
                            name = `${item.Event.name}  (${
                                item.Event.subStatus
                            })`;
                        } else {
                            name = item.name;
                        }

                        const map = {
                            events: item.name,
                            reports: item.Event && item.Event.name,
                            tasks: name
                        };
                        return map[key];
                    };

                    return {
                        ...newData,
                        [key]: payload.data[key].map(item => {
                            return {
                                code: item.id,
                                name: nameMap(key, item)
                            };
                        })
                    };
                },
                {}
            );
            dispatch(fetchCurrentlyAssignedToEventsSuccess(newPayload));
            dispatch(fetchCurrentlyAssignedToEventsLoading());
        });
    } else {
        //Reset everything when the user clear the values (x button on the react select)
        dispatch(resetState());
        dispatch(fetchCurrentlyAssignedToEventsLoading());
    }
};

export const fetchCurrentlyAssignedToEventsSuccess = data => {
    return {
        type: types.FETCH_CURRENTLY_ASSIGNED_TO_EVENTS_SUCCESS,
        data
    };
};

export const fetchCurrentlyAssignedToEventsLoading = () => {
    return {
        type: types.FETCH_CURRENTLY_ASSIGNED_TO_EVENTS_LOADING
    };
};

//Select all checkboxes for Events, Reports, and Tasks
export const selectAll = type => (dispatch, getState) => {
    let typeLength, dataMap;

    if (type === 'events') {
        dataMap = getState().admin.assignedData.events.map(x => x.code);
        typeLength = getState().adminForm.allEvents.length;
    } else if (type === 'reports') {
        dataMap = getState().admin.assignedData.reports.map(x => x.code);
        typeLength = getState().adminForm.allReports.length;
    } else if (type === 'tasks') {
        dataMap = getState().admin.assignedData.tasks.map(x => x.code);
        typeLength = getState().adminForm.allTasks.length;
    }

    if (typeLength) {
        dispatch(actions.change(`adminForm.${type}`, dataMap));
    } else {
        dispatch(actions.change(`adminForm.${type}`, []));
    }
    dispatch(counter());
};

//Events, Reports, Tasks Counter
export const counter = () => (dispatch, getState) => {
    let count;
    const adminFormEvents = getState().adminForm.events;
    const adminFormReports = getState().adminForm.reports;
    const adminFormTasks = getState().adminForm.tasks;
    const dataEvents = getState().admin.assignedData.events;
    const dataReports = getState().admin.assignedData.reports;
    const dataTasks = getState().admin.assignedData.tasks;
    count =
        adminFormEvents.length +
        adminFormReports.length +
        adminFormTasks.length;

    if (adminFormEvents.length !== dataEvents.length) {
        dispatch(actions.change('adminForm.allEvents', []));
    }

    if (adminFormReports.length !== dataReports.length) {
        dispatch(actions.change('adminForm.allReports', []));
    }

    if (adminFormTasks.length !== dataTasks.length) {
        dispatch(actions.change('adminForm.allTasks', []));
    }

    dispatch(counterSuccess(count));
};

export const counterSuccess = count => {
    return {
        type: types.COUNTER_SUCCESS,
        count
    };
};

export const resetState = (resetCurrentlyAssignedTo = false) => (
    dispatch,
    getState
) => {
    dispatch(counterSuccess(0));
    if (resetCurrentlyAssignedTo) {
        dispatch(actions.change('adminForm.currentlyAssignedTo', ''));
    }
    dispatch(actions.change('adminForm.allEvents', []));
    dispatch(actions.change('adminForm.allReports', []));
    dispatch(actions.change('adminForm.allTasks', []));
    dispatch(actions.change(`adminForm.events`, []));
    dispatch(actions.change(`adminForm.reports`, []));
    dispatch(actions.change(`adminForm.tasks`, []));
    dispatch(actions.change(`adminForm.reassignTo`, ''));
    dispatch(fetchReassignedToSuccess([]));
    dispatch(
        fetchCurrentlyAssignedToEventsSuccess({
            events: [],
            reports: [],
            tasks: []
        })
    );
};

export const fetchReassignTo = data => (dispatch, getState) => {
    if (data === '') {
        dispatch(fetchReassignedToSuccess([]));
        return false;
    }
    let regionalCode;
    let regionalBillets;
    let selectedBilletLocation = data.Billet.location;
    let selectedBilletName = data.Billet.name;

    const options = {
        OSS: {
            listOnlyBillets: billetList.oss
        },
        RSS: {
            listOnlyBillets: billetList.rss
        },
        RS: {
            listOnlyBillets: billetList.rsReportOnlyBillets
        },
        District: {
            listOnlyBillets: billetList.districtReportOnlyBillets
        }
    };

    if (['OSS', 'RSS', 'RS', 'District'].includes(selectedBilletLocation)) {
        selectedBilletLocation = 'District';
    }

    //Regional User
    if (selectedBilletLocation === 'Regional') {
        regionalCode = getRegionalCode(selectedBilletName);
        regionalBillets = selectedBilletName.includes('ERR')
            ? billetList.regionalReportOnlyBilletsEast
            : billetList.regionalReportOnlyBilletsWest;
    }

    /* prettier-ignore */
    const baseQuery = `&filter[User][id][ne]=${data.value}&filter[User][id][ne]=&fields[User]=id,firstName,lastName,rank&fields[Billet]=name,location&filter[MappedUsername.serviceProviderSymbol]=em2&filter[MappedUsername.allowed]=1`;

    const listOfBillets = {
        /* prettier-ignore */
        District: () =>`${endpoints.AUTH_USER_SEARCH}?include=Billet,MappedUsername,District,*RS,*RSS,*OSS&filter[District.code]=${data.district}${baseQuery}&filter[Billet.name][in]=${options[data.Billet.location].listOnlyBillets}&filter[User.isActive]=true`,
        /* prettier-ignore */
        MCRC: () => `${endpoints.AUTH_USER_SEARCH}?include=Billet,MappedUsername,*District,*RS,*RSS,*OSS${baseQuery}&filter[Billet.name][in]=${billetList.mcrcReportOnlyBillets}&filter[User.isActive]=true`,
        /* prettier-ignore */
        Regional: () => `${endpoints.AUTH_USER_SEARCH}?include=Billet,MappedUsername,*District,*RS,*RSS,*OSS&filter[District.code][in]=${regionalCode}${baseQuery}&filter[Billet.name][in]=${regionalBillets}&filter[User.isActive]=true`
    };

    /* prettier-ignore */
    apiRequest(
        listOfBillets[selectedBilletLocation](),
        getState().auth.jwtToken,
        'GET',
        undefined,
        false,
        2
    ).then(payload => {
        const userList = payload.data.map(item => {
            return {
                district: item.District && item.District.code,
                value: item.id,
                label: `${item.Billet.name} - ${item.rank} ${item.firstName} ${
                    item.lastName
                }`
            };
        });
        dispatch(fetchReassignedToSuccess(userList));
    });
};

export const fetchReassignedToSuccess = data => {
    return {
        type: types.FETCH_REASSIGNED_TO_SUCCESS,
        data
    };
};

export const reassignSubmitThunk = () => (dispatch, getState) => {
    dispatch(reassignSubmitLoading());
    let adminForm = getState().adminForm;
    let body = JSON.stringify({
        data: {
            events: adminForm.events,
            reports: adminForm.reports,
            tasks: adminForm.tasks
        }
    });
    apiRequest(
        `${endpoints.EMS}user/${adminForm.currentlyAssignedTo.value}/assign/${
            adminForm.reassignTo.value
        }`,
        getState().auth.jwtToken,
        'POST',
        body
    ).then(payload => {
        dispatch(resetState(true));
        dispatch(reassignSubmitThunkSuccess());
        dispatch(reassignSubmitLoading());
    });
};

export const reassignSubmitLoading = () => {
    return {
        type: types.REASSIGN_SUBMIT_LOADING
    };
};

export const reassignSubmitThunkSuccess = () => {
    return {
        type: types.SUBMISSION_REASSIGN_EVENTS_SUCCESS
    };
};

export const removeSubmissionBanner = () => {
    return {
        type: types.REMOVE_SUBMISSION_BANNER
    };
};



// WEBPACK FOOTER //
// ./src/actions/admin.js